import { render } from "./ImmediateTaggingDetailView.vue?vue&type=template&id=466d7593"
import script from "./ImmediateTaggingDetailView.vue?vue&type=script&lang=js"
export * from "./ImmediateTaggingDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__